export default __webpack_public_path__ + "static/media/27-marina-gallo-ophiuchus-jewels-paine-chile-travel-diary.fd33d059.jpg";